<template>
    <div class="kgr-inputGroup min-height">
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Auswertung') }}
        </h3>
        <kgr-form-row
            :label="$t('Start')"
            :error="error"
            :inline="true"
            field-name="start"
        >
            <kgr-date-picker
                v-model="start"
                @post-input="showSales()"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Ende')"
            :error="error"
            :inline="true"
            field-name="end"
        >
            <kgr-date-picker
                v-model="end"
                @post-input="showSales()"
            />
        </kgr-form-row>
        <br /><br />

        <kgr-button
            :value="$t('Verkäufe anzeigen')"
            :disabled="showSalesDisabled"
            :pending="pending"
            @click="showSales()"
        />

        <hr class="kgr-separator" />
        <kgr-sales-list-evaluation-table
            :member-club-fees="memberClubFees"
            is-member-context
        />
    </div>
</template>

<script>
import ClubSalesListEvaluationTable from '../../club/sales-list/ClubSalesListEvaluationTable';
import ClubSalesListMemberClubFeeRepository from '../../../js/repository/ClubSalesListMemberClubFeeRepository.js';
import DatePicker from '../../common/form/picker/DatePicker';
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import KgrButton from '../../common/form/button/KgrButton';
import moment from 'moment/moment';

export default {
    components: {
        'kgr-sales-list-evaluation-table': ClubSalesListEvaluationTable,
        'kgr-button': KgrButton,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            memberClubFees: [],
            start: this.startDate(),
            end: this.today(),
        };
    },
    computed: {
        showSalesDisabled() {
            return !this.isValidDate(this.start)
                || !this.isValidDate(this.end)
                || this.getDateFromString(this.start) > this.getDateFromString(this.end);
        },
    },
    mounted() {
        this.showSales();
    },
    methods: {
        today() {
            return moment(new Date(), 'YYYY-MM-DD').format('DD.MM.YYYY');
        },
        startDate() {
            return moment(new Date(), 'YYYY-MM-DD').subtract(1, 'months').format('DD.MM.YYYY');
        },
        showSales() {
            this.pending = true;
            const query = `?dateRange=${moment(this.start, 'DD.MM.YYYY').format('YYYY-MM-DD')}:${moment(this.end, 'DD.MM.YYYY').format('YYYY-MM-DD')}`;
            ClubSalesListMemberClubFeeRepository.findByMemberIdAndFilters(this.memberId, query)
                .then((response) => this.memberClubFees = response)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pending = false);
        },
        isValidDate(date) {
            return new RegExp('^([0-2]\\d|(3)[01])(\\.)(((0)\\d)|((1)[0-2]))(\\.)\\d{4}$').test(date);
        },
        getDateFromString(dateString) {
            return new Date(dateString.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1'));
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
